export const aboutInfo = {
  brandName: 'aigei',
  brandSlogan: '让创作更简单，让创意无限可能',
  foundingYear: '2018',
  mission: 'aigei 致力于打造国内最专业、最全面的游戏素材与音效资源平台。我们相信，优秀的创意不应该被资源所限制。通过提供海量高质量免费素材，我们希望帮助每一位游戏开发者、设计师和内容创作者将他们的创意变为现实。',
  story: 'aigei 诞生于一群游戏开发者的共同愿景。2018年，几位独立游戏开发者在经历了无数次"找不到合适素材"的困扰后，决定创建一个真正服务于创作者的素材平台。从最初的几千款素材起步，到如今汇聚超过50万款高质量资源，aigei 始终秉持"开放、共享、专业"的理念，为数百万创作者提供着源源不断的创意支持。',
  vision: '成为全球创作者首选的数字创意资源平台，推动游戏与数字内容产业的繁荣发展。',

  stats: [
    { value: '500,000+', label: '素材资源' },
    { value: '1,200,000+', label: '注册用户' },
    { value: '50+', label: '素材分类' },
    { value: '98%', label: '用户好评率' },
  ],

  team: [
    { name: '张伟', role: '创始人 & CEO', bio: '前腾讯游戏高级工程师，10年游戏开发经验', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20tech%20founder%20portrait%2C%20confident%20and%20friendly%2C%20warm%20lighting%2C%20clean%20studio%20background&width=200&height=200&seq=team-zhang&orientation=squarish' },
    { name: '李明', role: '技术总监', bio: '全栈工程师，开源社区活跃贡献者', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20software%20engineer%20portrait%2C%20young%20professional%2C%20smart%20casual%20look%2C%20warm%20lighting%2C%20clean%20background&width=200&height=200&seq=team-li&orientation=squarish' },
    { name: '王芳', role: '设计总监', bio: '资深游戏UI/UX设计师，曾参与多款畅销游戏设计', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20designer%20portrait%2C%20creative%20and%20elegant%2C%20warm%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=team-wang&orientation=squarish' },
    { name: '刘洋', role: '运营总监', bio: '数字内容平台运营专家，专注创作者生态建设', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20business%20professional%20portrait%2C%20friendly%20and%20approachable%2C%20modern%20office%2C%20warm%20lighting%2C%20clean%20background&width=200&height=200&seq=team-liu&orientation=squarish' },
  ],

  milestones: [
    { year: '2018', event: 'aigei 平台正式上线，首批10,000款素材发布' },
    { year: '2019', event: '注册用户突破10万，素材库扩展至50,000款' },
    { year: '2020', event: '推出音效和音乐素材分类，平台素材突破100,000款' },
    { year: '2021', event: '用户突破50万，上线AI智能推荐系统' },
    { year: '2022', event: '注册用户突破100万，推出VIP会员服务' },
    { year: '2023', event: '素材总量突破500,000款，成为国内最大游戏素材平台' },
    { year: '2024', event: '全面升级平台体验，推出素材质量认证体系' },
  ],

  testimonials: [
    { quote: 'aigei 是我开发独立游戏时最离不开的工具。无论是像素角色还是背景音乐，总能在这里找到合适的资源。', author: '独立游戏开发者 - 陈星', avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Chinese%20male%20developer%20avatar%20portrait%2C%20casual%20and%20happy%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=testimonial-01&orientation=squarish' },
    { quote: '作为一名音效设计师，aigei 不仅是我获取灵感的宝库，更是分享作品、与同行交流的优质社区。', author: '音效设计师 - 赵敏', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20audio%20designer%20avatar%2C%20confident%20and%20creative%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=testimonial-02&orientation=squarish' },
    { quote: '我们工作室的多个商业项目都在使用 aigei 的素材。质量高、选择多、授权清晰，是专业团队的首选。', author: '某游戏工作室主美 - 周杰', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20art%20director%20avatar%20portrait%2C%20stylish%20and%20professional%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=testimonial-03&orientation=squarish' },
  ],

  contact: {
    email: 'contact@aigei.com',
    phone: '400-888-9999',
    address: '北京市海淀区中关村软件园A座18层',
    wechat: 'aigei_official',
    qq: '800123456',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};

export const aboutFaqs = [
  {
    question: 'aigei 平台是如何确保素材质量的？',
    answer: 'aigei 建立了严格的素材审核机制。所有上传素材均需经过AI初筛和人工复审两道关卡，确保格式正确、内容完整、品质达标。2024年我们进一步推出了"精品认证"体系，由资深设计师和音效师组成的专家团队对高质量素材进行认证标注，方便用户快速识别优质资源。',
  },
  {
    question: 'aigei 的商业模式是什么？素材会一直免费吗？',
    answer: 'aigei 的核心素材库将始终保持免费开放。我们的收入主要来自VIP会员增值服务（不限量下载、优先体验等）和商业授权服务。此外，我们也在探索为大型企业客户提供定制化素材解决方案。我们承诺，基础的免费下载服务不会取消或缩水。',
  },
  {
    question: '如何与 aigei 进行商务合作？',
    answer: '我们欢迎各类合作！如果您是素材创作者，可以通过平台的创作者入驻计划分享您的作品并获得收益；如果您是企业客户，可以通过联系我们的商务团队（邮箱：business@aigei.com）探讨定制化合作方案。此外，我们也欢迎媒体采访、行业交流等合作邀约。',
  },
];